import { config } from '@config';
import { defineModel } from 'foca';

export interface ParrotCurrentRpcNode {
  rpc: string;
  rpcKey: keyof typeof config.rpc | 'custom';
}

export const globalSettingModel = defineModel('global-parrot', {
  initialState: <
    {
      slippage: string;
      isCustomSlippage: boolean;
      version: string;
      explorerKey: keyof typeof config.explorer_url;
      rpcKey: ParrotCurrentRpcNode['rpcKey'];
      limit: {
        slippage: string;
        isCustomSlippage: boolean;
      };
      liquiditySlippage: string;
    }
  >{
    slippage: '0.1',
    isCustomSlippage: false,
    explorerKey: 'suivision',
    rpcKey: 'shinami',
    limit: {
      slippage: '1',
      isCustomSlippage: false,
    },
    liquiditySlippage: '0.1',
  },
  reducers: {
    setCustomSlippage(state, slippage: string) {
      state.slippage = slippage;
      state.isCustomSlippage = true;
    },
    setEnumSlippage(state, slippage: string) {
      state.slippage = slippage;
      state.isCustomSlippage = false;
    },
    setExplorerKey(state, key: keyof typeof config.explorer_url) {
      state.explorerKey = key;
    },
    setRpcKey(state, key: ParrotCurrentRpcNode['rpcKey']) {
      state.rpcKey = key;
    },
    setLimitSlippage(state, slippage: string, isCustomSlippage: boolean) {
      state.limit = {
        slippage,
        isCustomSlippage,
      };
    },
    setLiquiditySlippage(state, slippage: string) {
      state.liquiditySlippage = slippage;
    },
  },
  methods: {
    explorerUrlForAccount(address: string) {
      const url =
        config.explorer_url[this.state.explorerKey]?.account || config.explorer_url.suiscan.account;
      return url.replace('{{account}}', address);
    },
    explorerUrlForObject(object: string) {
      const url =
        config.explorer_url[this.state.explorerKey]?.object || config.explorer_url.suiscan.object;
      return url.replace('{{object}}', object);
    },
    explorerUrlForCoin(coin: string) {
      const url =
        config.explorer_url[this.state.explorerKey]?.coin || config.explorer_url.suiscan.coin;
      return url.replace('{{coin}}', coin);
    },
    explorerUrlForTransaction(address: string) {
      const url =
        config.explorer_url[this.state.explorerKey]?.txb || config.explorer_url.suiscan.txb;
      return url.replace('{{txb}}', address);
    },
  },
});
